import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { DayGuideView } from "./DayGuideView";
import { api } from "../../lib/api";
import { WEEKDAYS } from "./MacroTable";

const Box = ({ title, children, testid }) => (
  <div className="qv-card-app" style={{ padding: 20, marginBottom: 16 }} data-testid={testid}>
    <div style={{ color: "var(--qv-red)", fontSize: 11, letterSpacing: "0.2em", textTransform: "uppercase", fontWeight: 700, marginBottom: 8 }}>{title}</div>
    {children}
  </div>
);

export const MyNutrition = () => {
  const [n, setN] = useState(null);
  const [req, setReq] = useState(null);
  const [open, setOpen] = useState(null);
  useEffect(() => {
    api.get("/me/nutrition-targets").then((r) => setN(r.data)).catch(() => {});
    api.get("/me/nutrition-info").then((r) => setReq(r.data.request)).catch(() => {});
  }, []);
  const banner = req?.status === "pending" && (
    <Box title="Tu entrenador necesita tus horarios" testid="my-nutrition-info-request">
      <div style={{ fontSize: 13, marginBottom: 10 }}>Para preparar tu guía nutricional por horarios, completa tus horarios de comidas, entrenamientos y partidos.</div>
      <Link to="/app/nutricion-datos" className="qv-btn-primary" style={{ display: "inline-block", padding: "10px 18px" }} data-testid="my-nutrition-info-link">Completar ahora</Link>
    </Box>
  );
  if (!n || n.state !== "published") return banner || null;
  const guideDay = (wi, wd) => n.guide?.weeks.find((w) => w.index === wi)?.days.find((x) => x.weekday === wd);
  const today = new Date().toLocaleDateString("sv-SE");
  const byKey = Object.fromEntries(n.day_types.map((t) => [t.key, t]));
  const todayWeek = n.weeks.find((w) => w.days.some((d) => d.date === today));
  const todayDay = todayWeek?.days.find((d) => d.date === today);
  const t = todayDay && byKey[todayDay.day_type];
  const todayGuide = todayDay && guideDay(todayWeek.index, todayDay.weekday);
  return (<>
    {banner}
    {t && (
      <Box title="Tu objetivo nutricional de hoy" testid="my-nutrition-today">
        <div style={{ fontWeight: 700, marginBottom: 6 }} data-testid="my-nutrition-today-type">{t.label}</div>
        <div style={{ display: "flex", gap: 18, flexWrap: "wrap", fontSize: 14 }}>
          <span data-testid="my-nutrition-today-kcal"><b style={{ fontSize: 22 }}>{t.kcal}</b> kcal</span>
          <span>Proteínas <b>{t.protein_g} g</b></span><span>Grasas <b>{t.fat_g} g</b></span><span>Carbohidratos <b>{t.carbs_g} g</b></span>
        </div>
        {todayGuide && <div style={{ marginTop: 14 }}><DayGuideView day={todayGuide} testid="my-nutrition-today-guide" /></div>}
      </Box>
    )}
    <Box title="Nutrición · energía y macronutrientes por tipo de día" testid="my-nutrition">
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: 10 }} data-testid="my-nutrition-table">
        {n.day_types.map((t) => (
          <div key={t.key} style={{ border: "1px solid rgba(255,255,255,0.08)", padding: 12 }} data-testid={`my-nutrition-table-row-${t.key}`}>
            <div style={{ fontWeight: 700, fontSize: 13, marginBottom: 4 }}>{t.label}</div>
            <div style={{ fontSize: 20, fontWeight: 800 }} data-testid={`my-nutrition-table-kcal-${t.key}`}>{t.kcal} kcal</div>
            <div style={{ fontSize: 12, color: "#d4d4d4", marginTop: 4, display: "grid", gap: 2 }}>
              <span>Proteínas <b>{t.protein_g} g</b></span><span>Grasas <b>{t.fat_g} g</b></span><span>Carbohidratos <b>{t.carbs_g} g</b></span>
            </div>
          </div>
        ))}
      </div>
      {n.minor_note && <div className="emp-note" style={{ marginTop: 12 }} data-testid="my-nutrition-minor">{n.minor_note}</div>}
      <div style={{ fontSize: 12, color: "#737373", marginTop: 10 }} data-testid="my-nutrition-disclaimer">{n.disclaimer}</div>
    </Box>
    <Box title={n.guide ? "Tu guía nutricional por jornadas" : "Tipo de día en tu planificación"} testid="my-nutrition-weeks">
      {n.guide && <div style={{ fontSize: 12, color: "#a3a3a3", marginBottom: 10 }}>Pulsa un día para ver horarios, comidas, cantidades e hidratación. {n.disclaimer}</div>}
      {n.weeks.map((w) => (
        <div key={w.index} style={{ marginBottom: 10 }}>
          <div style={{ fontWeight: 700, fontSize: 13 }}>{w.label || `Semana ${w.index + 1}`}</div>
          {n.guide ? (
            <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: 6 }}>
              {w.days.map((d) => {
                const k = `${w.index}-${d.weekday}`;
                return <button key={k} onClick={() => setOpen(open === k ? null : k)} data-testid={`my-nutrition-day-${k}`}
                  style={{ background: open === k ? "var(--qv-red, #E11D2E)" : "transparent", border: "1px solid rgba(255,255,255,0.15)", color: "#fff", padding: "6px 10px", fontSize: 12, cursor: "pointer" }}>
                  {d.weekday_label || WEEKDAYS[d.weekday]} · {d.label}{byKey[d.day_type] ? ` · ${byKey[d.day_type].kcal} kcal` : ""}</button>;
              })}
            </div>
          ) : <div style={{ fontSize: 12, color: "#a3a3a3" }}>{w.days.map((d) => `${d.weekday_label || WEEKDAYS[d.weekday]}: ${d.label}${byKey[d.day_type] ? ` (${byKey[d.day_type].kcal} kcal)` : ""}`).join(" · ")}</div>}
          {n.guide && open?.startsWith(`${w.index}-`) && guideDay(w.index, Number(open.split("-")[1])) && (
            <div style={{ marginTop: 10, padding: 12, border: "1px solid rgba(255,255,255,0.08)" }}><DayGuideView day={guideDay(w.index, Number(open.split("-")[1]))} testid={`my-nutrition-guide-${open}`} /></div>
          )}
        </div>
      ))}
    </Box>
  </>);
};
